import { AppError, ErrorCode } from '../types';

export function fromStorageError(err: any): AppError {
  const code = String(err?.code ?? '');
  if (code === 'storage/unauthorized') return new AppError({ code: ErrorCode.DB_PERMISSION_DENIED, domain: 'storage', cause: err });
  if (code === 'storage/quota-exceeded') return new AppError({ code: ErrorCode.DB_UNAVAILABLE, domain: 'storage', cause: err });
  return new AppError({ code: ErrorCode.UNKNOWN, domain: 'storage', cause: err });
}
